import React from 'react'

import { Chip } from '@heroui/react'
import { NavLink } from 'react-router-dom'

export interface SidebarItemProps {
  to: string
  icon: React.ReactNode
  label: string
  badge?: React.ReactNode
  badgeColor?: "default" | "primary" | "secondary" | "success" | "warning" | "danger"
}

export function SidebarItem({ to, icon, label, badge, badgeColor = "default" }: SidebarItemProps) {
  return (
    <NavLink
      to={to}
      className={({ isActive }) =>
        `flex items-center gap-3 px-3 py-2.5 rounded-2xl text-sm transition-colors ${
          isActive
            ? 'bg-black/5  font-medium dark:bg-white/10'
            : 'text-foreground/60 hover:bg-foreground/5 '
        }`
      }
    >
      {({ isActive }) => (
        <>
          <span className={isActive ? 'text-black dark:text-white' : 'text-foreground/70'}>{icon}</span>
          {label}
          {!!badge && (
            <Chip className="ml-auto" color={badgeColor as any}> {badge}</Chip>
          )}
        </>
      )}
    </NavLink>
  )
}
